import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../features/auth/context/AuthContext';

/**
 * Componente para proteger rutas de administrador
 * Solo permite acceso a usuarios autenticados con tipo 'admin'
 * Compatible con el sistema de autenticación JWT
 */
const AdminRoute = () => {
  const { user, loading, isAuthenticated, tokenData } = useAuth();
  
  // Mientras se verifica la autenticación, mostrar indicador de carga
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  }
  
  // Si no está autenticado, redirigir al login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  // Verificar si es administrador usando el token JWT si está disponible
  // o el objeto de usuario de Parse como respaldo
  const isAdmin = 
    (tokenData && tokenData.userType === 'admin') || 
    (user && (user.get('type') === 'admin' || user.get('userType') === 'admin'));
  
  // Si está autenticado pero no es admin, redirigir a la página principal
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }
  
  // Si es admin, mostrar el contenido protegido
  return <Outlet />;
};

export default AdminRoute;
